exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 30em) {\n.centered-container-ns[data-v-c0cf6a9c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 100vh;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n}\n.border-login[data-v-c0cf6a9c] {\n  border: 1px solid #E8E8E8;\n}\n#login-card[data-v-c0cf6a9c] {\n  -ms-flex-preferred-size: 24rem;\n      flex-basis: 24rem;\n  padding-top: 1rem;\n  padding-bottom: 2rem;\n}\n.sideSpan[data-v-c0cf6a9c] {\n    position: relative;\n    left: 7px;\n    bottom: -28px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c0cf6a9c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login.vue
// module id = 1385
// module chunks = 0